import { Pagination, PaginationFilterDto } from "../../../types/Pagination";
import { ReportDefinitionFormDto, ReportDefinitionFormSelectorsDto, ReportDefinitionListItemDto } from "../types";
import { apiService } from "../../../services/api/apiService";
import { downloadCsvFile } from "../../../utils/downloadCsvFile";
import { DeleteReasonIdDto } from "../../../types/DeleteReasonIdDto";

const BASE_URL = "/reportDefinitions";

export const getSelectorsData = async (): Promise<ReportDefinitionFormSelectorsDto> => 
    await apiService.get<ReportDefinitionFormSelectorsDto>(`${BASE_URL}/selectors-data`)

export const getReportDefinitions = async (
    body: PaginationFilterDto
): Promise<Pagination<ReportDefinitionListItemDto>> => 
    await apiService.post<PaginationFilterDto, Pagination<ReportDefinitionListItemDto>>(`${BASE_URL}/`, body)
 
export const deleteLogicReportDefinition = async (ReportDefinitionId: number, body: DeleteReasonIdDto): Promise<void> => 
    await apiService.put<DeleteReasonIdDto, void>(`${BASE_URL}/delete/${ReportDefinitionId}`, body)

export const getReportDefinitionById = async (ReportDefinitionId: number): Promise<ReportDefinitionFormDto> =>
    await apiService.get<ReportDefinitionFormDto>(`${BASE_URL}/${ReportDefinitionId}`)

export const createReportDefinition = async (body: ReportDefinitionFormDto): Promise<ReportDefinitionFormDto> =>
    await apiService.post<ReportDefinitionFormDto, ReportDefinitionFormDto>(`${BASE_URL}/create`, body)

export const updateReportDefinition = async (ReportDefinitionId: number, body: ReportDefinitionFormDto): Promise<ReportDefinitionFormDto> =>
    await apiService.put<ReportDefinitionFormDto, ReportDefinitionFormDto>(`${BASE_URL}/${ReportDefinitionId}`, body)

export const exportReportDefinitionsToCsv = async (filters: PaginationFilterDto): Promise<void> => {
    try {
        const result = await apiService.post<PaginationFilterDto, any>(`${BASE_URL}/exportToCsv`, filters, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        downloadCsvFile(result, "improvement_plans_export.csv");
    } catch (error) {
        console.error("Error downloading CSV", error);
        throw error;
    }
}
